import { createSlice } from '@reduxjs/toolkit';
export const toastSlice = createSlice({
  name: 'toast',
  initialState: {
    show: false,
    message: null,
    variant: 'success',
    reportable: false
  },
  reducers: {
    showToast(state, action) {
      state.show = true;
      state.message = action.payload.message;
      state.variant = action.payload.variant || 'success';
      state.reportable = action.payload.reportable || false;
    },
    hideToast(state) {
      state.show = false;
    }
  }
});
export const {
  showToast,
  hideToast
} = toastSlice.actions;
export default toastSlice.reducer;